import { useTranslation } from 'react-i18next';
import { AnalyticsPercentTrend } from '@features/analytics-weekly';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Grid,
  KpiCard,
  KpiCardCompact,
  Stack,
} from '@shared/ui';

export function KpiCardShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.dataDisplay.kpiCard.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.dataDisplay.kpiCard.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Stack gap="lg">
          <Grid cols={2} gap="md" className="grid-cols-1 md:grid-cols-2">
            <KpiCard
              title={t('uiLibrary.dataDisplay.kpiCard.examples.registrations.title')}
              value={312}
              subtext={t('uiLibrary.dataDisplay.kpiCard.examples.registrations.description')}
              trend={
                <AnalyticsPercentTrend
                  context={t('analytics.weekly.labels.vsAvg', 'vs avg')}
                  value={-14.01}
                />
              }
              size="md"
              locale="en-US"
            />
            <KpiCard
              title={t('uiLibrary.dataDisplay.kpiCard.examples.instructors.title')}
              value={902}
              subtext={t('uiLibrary.dataDisplay.kpiCard.examples.instructors.description')}
              trend={
                <AnalyticsPercentTrend
                  context={t('analytics.weekly.labels.vsAvg', 'vs avg')}
                  value={7.62}
                />
              }
              size="md"
              locale="en-US"
            />
          </Grid>
          <Grid cols={3} gap="md" className="grid-cols-1 md:grid-cols-3">
            <KpiCardCompact
              label={t('uiLibrary.dataDisplay.kpiCard.examples.registrations.title')}
              value={312}
              trend={
                <AnalyticsPercentTrend
                  context={t('analytics.weekly.labels.vsAvg', 'vs avg')}
                  value={4.01}
                />
              }
            />
            <KpiCardCompact
              label={t('uiLibrary.dataDisplay.kpiCard.examples.instructors.title')}
              value={902}
              trend={
                <AnalyticsPercentTrend
                  context={t('analytics.weekly.labels.vsAvg', 'vs avg')}
                  value={7.62}
                />
              }
            />
            <KpiCardCompact
              label={t('uiLibrary.dataDisplay.kpiCard.examples.registrations.title')}
              value={t('analytics.weekly.notAvailable', 'N/A')}
            />
          </Grid>
        </Stack>
      </CardContent>
    </Card>
  );
}
